import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';

@Component({
  selector: 'app-grupo-editar',
  templateUrl: './grupo-editar.component.html',
  styleUrls: ['./grupo-editar.component.scss']
})
export class GrupoEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  id?: number;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  loading: boolean = false;
  empresaSelecionada?: Empresa;
  grupo?: Grupo = {};
  tipos: PlanoContaEmpresa[] = [];
  listaSubgrupos: Subgrupo[] = [];
  subgrupo: Subgrupo = {};
  tributacoes: TributacaoEmpresa[] = [];
  modalNenhumSubgrupo: boolean = false;
  grupoServico: boolean = false;
  temSubgrupos: boolean = false;
  excluir: boolean = false;
  progressoRequisicao: boolean = false;
  exibirRedirecionarExcluido: boolean = false;

  constructor(private activatedRouter: ActivatedRoute, 
    private grupoService: GrupoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private subgrupoService: SubgrupoService,
    private tributacaoEmpresaService: TributacaoEmpresaService,
    private erroService: ErroService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private _router: Router) {
     }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.loading = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_GRUPO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdGrupo();
    if (this.permissaoEditar) {
      this.carregarTipos();
    }
  }

  carregarTipos(){
    const codigos = [3, 4];
    if(this.empresaSelecionada?.id) {
      this.planoContaEmpresaService.listarPorEmpresaECodigo(this.empresaSelecionada.id, codigos).subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.tipos = data;
          this.carregarGrupoPorId();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      });
    }
    
  }

  carregarGrupoPorId(){
    this.grupoService.buscarPorId(this.id).subscribe({
      next: (data: Grupo) => {
        this.grupo = data;
        this.carregarTributacoes();
        if(this.grupo.planoContaEmpresa?.id === 4){
          this.grupoServico = true;
        }
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  carregarTributacoes(){
    let tipo = this.grupo?.planoContaEmpresa?.codigo === 3 ?
     'DANFE' : (this.grupo?.planoContaEmpresa?.codigo === 4 ? 'RPS' : '');
    this.tributacaoEmpresaService.listarPorEmpresaETipo(this.empresaSelecionada?.id, tipo).subscribe({
      next: (data: TributacaoEmpresa[]) => {
        this.tributacoes = data;
        this.carregarSubgrupos();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  atualizarGrupo(){
    if(this.listaSubgrupos.length < 1){
      this.modalNenhumSubgrupo = true;
    } else {
      this.progressoRequisicao = true;
      this.grupoService.atualizarGrupo(this.id, this.grupo).subscribe({
        next: () => {
          this.atualizarSubgrupo();
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.progressoRequisicao = false;
          this.rolarTela();
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.progressoRequisicao = false;
          this.rolarTela();
        }
      });
    }
  }

  atualizarSubgrupo(){
      for(const subgrupo of this.listaSubgrupos){
        if(subgrupo.id){
          this.subgrupoService.atualizarSubgrupo(subgrupo.id, subgrupo).subscribe({
            next: (data: Subgrupo) => {
              console.log('Subgrupo Atualizado:', data)
            },
            error: (err: any) => {
              this.messages = this.erroService.handleErro(err);
              this.messagemVisivel = true;
              this.rolarTela();
            }
          })
        } else {
          subgrupo.grupo = this.grupo;
          this.subgrupoService.salvarSubgrupo(subgrupo).subscribe({
            next: (data: Subgrupo) => {
              console.log('Sugrupo Salvo: ', data);
            },
            error: (err: any) => {
              this.messages = this.erroService.handleErro(err);
              this.messagemVisivel = true;
              this.rolarTela();
            }
          })
        }
      }
      
  }

  

  

  


  carregarSubgrupos(){
    this.subgrupoService.listarSubgruposPorGrupoId(this.grupo?.id).subscribe({
      next: (data: Subgrupo[]) => {
        this.loading = false;
        this.listaSubgrupos = data;
        if(this.listaSubgrupos.length < 1){
          this.excluirGrupo();
        }
          
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  

  adicionarSubgrupo(){
    if(this.grupo?.planoContaEmpresa?.codigo === 4){
      this.subgrupo.rateioBasico = this.subgrupo.rateioBasico ?
      this.subgrupo.rateioBasico : 0;
    } else {
      this.subgrupo.rateioBasico = 0;
    }
    this.subgrupo.descricao = FormatacaoUtil.removerCaracteresEspeciais(this.subgrupo.descricao);
    this.listaSubgrupos.push(this.subgrupo);
    this.subgrupo = {};
    this.excluir = false;
  }

  

  carregarIdGrupo(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  excluirGrupo(){
    this.confirmationService.confirm({
      message: 'Deseja excluir o grupo?',
      header: 'Nenhum subgrupo cadastrado',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.grupoService.excluirGrupo(this.grupo?.id).subscribe({
          next: () => {
            this.exibirRedirecionarExcluido = true;
            
          },
          error: (err: any) =>{
            this.exibirRedirecionarExcluido = false;
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          } 
        });
        
      }
    });
  }

  excluirSubgrupo(subgrupo: Subgrupo){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.subgrupoService.excluir(subgrupo.id).subscribe({
          next: () => {
            this.carregarSubgrupos();
            
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
      }
    });
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }
  

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  redirecionarListagem(){
    this._router.navigate(["/apps/grupo/"], { relativeTo: this.activatedRouter })
  }

}
